<template>
    <div>
<!--        <breadcrumb :routerList="[{to:'/rebate',title:'信贷管理'},{title:'订单赊销'}]"/>-->
      <Breadtabsheader/>
        <div class="h-content">
            <div class="h-piece">
                <div class="h-formBox zhi">
                    <el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder">
						<div class="h-thirdColumn w-newColumn">
							<el-form-item label="订单编号">
							    <el-input v-model="formInline.sapCode" placeholder=""></el-input>
							</el-form-item>
							<el-form-item label="销售地区">
								<el-input v-model="formInline.city1" placeholder="模糊搜索"></el-input>
							</el-form-item>
							<el-form-item  label="订单类型">
								<brselect
									style="width:100%"
									clearable
									category="cr_type"
									:v="formInline.orderCategory"
									v-model="formInline.orderCategory"
									 placeholder="--请选择--">
								</brselect>
							</el-form-item>

							<el-form-item label="销售组织">
								<brselect
									style="width:100%"
									clearable
									category="kkber_value"
									:v="formInline.gscode"
									v-model="formInline.gscode"
									 placeholder="--请选择--">
								</brselect>
							</el-form-item>
						</div>
						<el-collapse-transition>
							<div v-show="isScreen">
								<div class="h-thirdColumn w-newColumn">
									<el-form-item label="国家">
										<brselect
											style="width:100%"
											clearable
											category="YLCountry_agent"
											:v="formInline.land1"
											v-model="formInline.land1"
											 placeholder="--请选择--">
										</brselect>
									</el-form-item>
									<el-form-item label="订单号">
										<el-input v-model="formInline.add2" placeholder=""></el-input>
									</el-form-item>
										<el-form-item label="　　系统发票号">
											<el-input v-model="formInline.add4" placeholder=""></el-input>
										</el-form-item>
										<el-form-item label="售达方编码或名称">
											<el-input v-model="formInline.soldToCode" placeholder=""></el-input>
										</el-form-item>
								</div>
								<div class="h-thirdColumn w-newColumn">
									<el-form-item label="发票日期" style="width: 50%;">
										<el-date-picker
												placeholder="请选择"
										        v-model="formInline.add5"
										        clearable
										        type="date"
										        value-format="yyyy-MM-dd" >
										</el-date-picker>
										<span class="w-time-to">至</span>
										<el-date-picker
												placeholder="请选择"
										        v-model="formInline.add5I"
										        clearable
										        type="date"
										        value-format="yyyy-MM-dd" >
										</el-date-picker>
									</el-form-item>
									<el-form-item label="提单号">
										<el-input v-model="formInline.zztidh" placeholder=""></el-input>
									</el-form-item>
									<el-form-item label="凭证编码">
										<el-input v-model="formInline.belnr" placeholder=""></el-input>
									</el-form-item>
								</div>
								<div class="h-thirdColumn w-newColumn">
									<el-form-item label="订单日期" style="width: 50%;">
										<el-date-picker
												placeholder="请选择"
										        v-model="formInline.sptgTime"
										        clearable
										        type="date"
										        value-format="yyyy-MM-dd" >
										</el-date-picker>
										<span class="w-time-to">至</span>
										<el-date-picker
												placeholder="请选择"
										        v-model="formInline.sptgTime1"
										        clearable
										        type="date"
										        value-format="yyyy-MM-dd" >
										</el-date-picker>
									</el-form-item>
									<el-form-item label="报关单号">
										<el-input v-model="formInline.zzbgdh" placeholder=""></el-input>
									</el-form-item>
									<el-form-item label="中心经理">
										<el-input v-model="formInline.zzzxjl" placeholder=""></el-input>
									</el-form-item>
								</div>
								<div class="h-thirdColumn w-newColumn">

									<el-form-item label="　　议付发票号">
										<el-input v-model="formInline.zzyffp" placeholder=""></el-input>
									</el-form-item>
									<el-form-item label="箱单号">
										<el-input v-model="formInline.xdhao" placeholder=""></el-input>
									</el-form-item>
									<el-form-item  label="订单子类型">
										<brselect
												style="width:100%"
												clearable
												category="xiaoshou_quyu_nwx"
												:v="formInline.orderCategory1"
												v-model="formInline.orderCategory1"
												placeholder="--请选择--">
										</brselect>
									</el-form-item>
								</div>
							</div>
						</el-collapse-transition>
                       <!-- <div class="h-formBtnOut h-columnCenter">
                            <el-button class="h-btn h-formBtn" @click="selectData">检索</el-button>
                            <el-button class="h-btn h-formBtn h-bgwhite" @click="resectData">重置
                            </el-button>
                        </div> -->
                    </el-form>
					<div class="l-screenBox">
						<div class="l-screen" @click="collapseChange">
							<img :src="isScreen?closeScreen:drawScreen" alt="">
							<div class="l-screenText">{{isScreen?"收起":"展开"}}</div>
						</div>
						<div class="l-retrieval">
							<el-button class="h-btn h-formBtn" @click="selectData">检索</el-button>
							<el-button class="h-btn h-formBtn h-bgwhite" @click="resectData">重置
							</el-button>
						</div>
					</div>
                </div>
            </div>
            <div class="h-row">
                <div class="h-rowIn" style="width:100%;">
                    <div style="background:#fff;width:100%;">
                        <el-table
                                ref="multipleTable"
                                @selection-change="handleSelectionChange"
                                :data="tableData2"
                                stripe
								border
                                style="width: 100%"
								max-height="460"
                        >
							<!--<el-table-column-->
								<!--type="selection"-->
								<!--width="40"-->
								<!--label="全选">-->
							<!--</el-table-column>-->
                            <el-table-column
                                    type="index"
                                    width="40"
                                    label="#"
                                    fixed>
                            </el-table-column>
                            <el-table-column
                                    prop="sapCode"
                                    label="订单编号"
									 :show-overflow-tooltip="true"
                                    fixed
                                    width="120">
                            </el-table-column>
							<el-table-column
									prop="orderCategory"
									label="订单类型"
									:show-overflow-tooltip="true"
									fixed
									width="90">
								<template slot-scope="scope" >
									<dictname category="cr_type" :v="scope.row.orderCategory" />
								</template>
							</el-table-column>
							<el-table-column
									prop="orderCategory1"
									label="订单子类型"
									:show-overflow-tooltip="true"
									width="130">
								<template slot-scope="scope" >
									<dictname category="xiaoshou_quyu_nwx" :v="scope.row.orderCategory1" />
								</template>
							</el-table-column>
                            <el-table-column
                                    prop="city1"
                                    label="销售地区"
									 :show-overflow-tooltip="true"
                                    fixed
                                    width="90">
                            </el-table-column>
							<el-table-column
							        prop="land1"
							        label="国家"
									 :show-overflow-tooltip="true"
                                    fixed
							        width="80">
								<template slot-scope="scope" >
									<dictname category="YLCountry_agent" :v="scope.row.land1" />
								</template>
							</el-table-column>
                            <el-table-column
                                    prop="gscode"
                                    label="销售组织"
                                    :show-overflow-tooltip="true"
                                    fixed
                                    width="90">
                            </el-table-column>
							<el-table-column
							        prop="soldToName"
							        label="售达方名称"
									 :show-overflow-tooltip="true"
                                    fixed
							        min-width="180">
									<template slot-scope="scope">
										<div style="text-align: left;">
											{{scope.row.soldToName}}
										</div>
									</template>
							</el-table-column>
							<el-table-column
							        prop="soldToCode"
							        label="售达方"
									 :show-overflow-tooltip="true"
							        width="110">
							</el-table-column>
							<el-table-column
							        prop="soldToName"
							        label="收票方名称"
									 :show-overflow-tooltip="true"
							        width="180">
									<template slot-scope="scope">
										<div style="text-align: left;">
											{{scope.row.soldToName}}
										</div>
									</template>
							</el-table-column>
							<el-table-column
							        prop="soldToCode"
							        label="收票方"
									 :show-overflow-tooltip="true"
							        width="110">
							</el-table-column>
							<el-table-column
							        prop="add2"
							        label="订单号"
									 :show-overflow-tooltip="true"
							        width="120">
							</el-table-column>
							<el-table-column
							        prop="sptgTime"
							        label="订单日期"
									 :show-overflow-tooltip="true"
							        width="120">
								<template scope="scope">
									{{scope.row.sptgTime?scope.row.sptgTime.substring(0,10):''}}
								</template>
							</el-table-column>
							<el-table-column
							        prop="zzzxjl"
							        label="中心经理"
									 :show-overflow-tooltip="true"
							        width="100">
							</el-table-column>
							<el-table-column
							        prop="proNumber"
							        label="数量"
									 :show-overflow-tooltip="true"
							        width="60">
										<template slot-scope="scope">
											<div style="text-align: right;">
												{{scope.row.proNumber}}
											</div>
										</template>
							</el-table-column>
							<el-table-column
							        prop="currencyCode"
							        label="币种"
									 :show-overflow-tooltip="true"
							        width="70">
							</el-table-column>
							<el-table-column
							        prop="netwr"
							        label="订单金额"
									 :show-overflow-tooltip="true"
							        width="90">
									<template slot-scope="scope">
										<div style="text-align: right;">
											{{scope.row.netwr}}
										</div>
									</template>
							</el-table-column>
							<el-table-column
							        prop="add4"
							        label="系统发票号"
									 :show-overflow-tooltip="true"
							        width="120">
							</el-table-column>
							<!--<el-table-column-->
									<!--prop="bktxt"-->
									<!--label="纸质发票号"-->
									<!--:show-overflow-tooltip="true"-->
									<!--width="140">-->
							<!--</el-table-column>-->
							<el-table-column
							        prop="belnr"
							        label="凭证编码"
									 :show-overflow-tooltip="true"
							        width="110">
							</el-table-column>
							<el-table-column
							        prop="add5"
							        label="开票日期"
									 :show-overflow-tooltip="true"
							        width="100">
								<template scope="scope">
									{{scope.row.add5?scope.row.add5.substring(0,10):''}}
								</template>
							</el-table-column>
							<el-table-column
							        prop="wrbtr"
							        label="开票金额"
									 :show-overflow-tooltip="true"
							        width="90">
									<template slot-scope="scope">
										<div style="text-align: right;">
											{{scope.row.wrbtr}}
										</div>
									</template>
							</el-table-column>
							<!--<el-table-column-->
									<!--prop="kursf"-->
									<!--label="汇率"-->
									<!--:show-overflow-tooltip="true"-->
									<!--width="80">-->
								<!--<template scope="scope">-->
									<!--{{scope.row.kursf?scope.row.kursf:''}}-->
								<!--</template>-->
							<!--</el-table-column>-->
							<el-table-column
							        prop="belnr1"
							        label="已取消发票号"
									 :show-overflow-tooltip="true"
							        width="150">
							</el-table-column>
							<el-table-column
							        prop="zzyffp"
							        label="议付发票号"
									 :show-overflow-tooltip="true"
							        width="130">
							</el-table-column>
							<el-table-column
									prop="xdhao"
									label="箱单号"
									:show-overflow-tooltip="true"
									width="130">
							</el-table-column>
							<!--<el-table-column-->
									<!--prop="orderCategory1"-->
									<!--label="订单子类型"-->
									<!--:show-overflow-tooltip="true"-->
									<!--width="130">-->
								<!--<template slot-scope="scope" >-->
									<!--<dictname category="xiaoshou_quyu_nwx" :v="scope.row.orderCategory1" />-->
								<!--</template>-->
							<!--</el-table-column>-->
							<el-table-column
							        prop="zzyfrq"
							        label="议付发票日期"
									 :show-overflow-tooltip="true"
							        width="150">
								<template scope="scope">
									{{scope.row.zzyfrq?scope.row.zzyfrq.substring(0,10):''}}
								</template>
							</el-table-column>
							<el-table-column
							        prop="fktj"
							        label="付款方式"
									 :show-overflow-tooltip="true"
							        width="90">
							</el-table-column>
							<el-table-column
							        prop="ztag1"
							        label="付款周期"
									 :show-overflow-tooltip="true"
							        width="90">
							</el-table-column>
							<el-table-column
							        prop="zzxyzh"
							        label="信用证号及信用证金额"
									 :show-overflow-tooltip="true"
							        width="200">
							</el-table-column>
							<el-table-column
							        prop="zztidh"
							        label="提单号"
									 :show-overflow-tooltip="true"
							        width="140">
							</el-table-column>
							<el-table-column
							        prop="zztidr"
							        label="实际出口日期"
									 :show-overflow-tooltip="true"
							        width="120">
								<template scope="scope">
									{{scope.row.zztidr?scope.row.zztidr.substring(0,10):''}}
								</template>
							</el-table-column>
							<el-table-column
							        prop="zzbgdh"
							        label="报关单号"
									 :show-overflow-tooltip="true"
							        width="150">
							</el-table-column>
							<el-table-column
							        prop="zzyfrq1"
							        label="实议付日"
									 :show-overflow-tooltip="true"
							        width="120">
								<template scope="scope">
									{{scope.row.zzyfrq1?scope.row.zzyfrq1.substring(0,10):''}}
								</template>
							</el-table-column>
							<el-table-column
							        prop="validitydate"
							        label="应收汇日"
									 :show-overflow-tooltip="true"
							        width="100">
								<template scope="scope">
									{{scope.row.validitydate?scope.row.validitydate.substring(0,10):''}}
								</template>
							</el-table-column>
							<el-table-column
							        prop="budat"
							        label="实际收汇日期"
									 :show-overflow-tooltip="true"
							        width="120">
								<template scope="scope">
									{{scope.row.budat?scope.row.budat.substring(0,10):''}}
								</template>
							</el-table-column>
							<el-table-column
							        prop="shje"
							        label="收汇金额"
									 :show-overflow-tooltip="true"
							        width="90">
										<template slot-scope="scope">
											<div style="text-align: right;">
												{{scope.row.shje}}
											</div>
										</template>
							</el-table-column>
							<el-table-column
							        prop="ye"
							        label="余额"
									 :show-overflow-tooltip="true"
							        width="70">
										<template slot-scope="scope">
											<div style="text-align: right;">
												{{scope.row.ye}}
											</div>
										</template>
							</el-table-column>
							<el-table-column
									label="操作"
									width="100"
									fixed="right"
							>
								<template slot-scope="scope">
									<div>
										<el-button
												size="small" class="h-tableLink h-btn"
												@click="seeFile(scope.row)">查看附件
										</el-button>
									</div>
								</template>
							</el-table-column>

                        </el-table>
                    </div>
					<el-dialog
							:visible.sync="showFujianD"
							v-if="showFujianD"
							class="h-dialog2"
					>
						<div class="h-dialogImg">
							<div class="h-disTable">
								<div class="h-tableCell">
									<h1>外销订单凭证总览</h1>
								</div>
							</div>
						</div>
						<div class="h-formLine" style="padding:20px;border-bottom: 1px dashed #ccc;">
							<h3 style="display: inline-block;">订单号:</h3>
							<h4 style="display: inline-block;margin-left: 0.1rem;">{{ddhU}}</h4>
						</div>
						<div class="h-formLine" style="padding:20px;border-bottom: 1px dashed #ccc;">
							<h3 style="display: inline-block;">报关单</h3>
							<brupload
									style="margin-top: 0.1rem;"
									:refid="refid"
									reftype="WXFJ_BGD"
									:showtime="false"
							/>
						</div>
						<div class="h-formLine" style="padding:20px;border-bottom: 1px dashed #ccc;">
							<h3 style="display: inline-block;">入货通知</h3>
							<brupload
									style="margin-top: 0.1rem;"
									:refid="refid"
									reftype="WXFJ_RHTZ"
									:showtime="false"
							/>
						</div>
						<div class="h-formLine" style="padding:20px;">
							<h3 style="display: inline-block;">提单</h3>
							<brupload
									style="margin-top: 0.1rem;"
									:refid="refid"
									reftype="WXFJ_TD"
									:showtime="false"
									/>
						</div>
					</el-dialog>

                    <div class="h-tableB h-mrt30">
                        <div class="h-tableBL">
								<el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="downloadExcel">批量导出</el-button>
                        </div>
                        <div class="h-pagination2">
                            <pagination :page="q" @query="selectDataPage"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import customerLedgerService from "../../../api/loud/credit/customerLedgerService";
    import util from "../../../utils/util";
    import updownfile from "../../../utils/updownfile";

    export default {
        data() {
            return {
				// 展开折叠筛选
				isScreen:false,
				closeScreen:require("@/assets/images/pimg/closeallic.png"),
				drawScreen:require("@/assets/images/pimg/dobleArr.png"),
				
				moreCondition: false,
                userInfoCreditVo:{
                    multipleSelection: [],
                },
				showFujianD:false,
				value1:'',
                value2: '',
                value3: 36,
                names: '',
                input1: '',
                sele: '工程',
                formInline: {
					sptgTime:null,
					sptgTime1:null,
					add5:null,
					add5I:null,
					orderCategory:null,
					add5:null,
					add5I:null,
					sptgTime1:null,
					sptgTime:null,
					add4:null,
					gscode:null,
					zztidh:null,
                	sapCode:null,
					soldToCode:null,
                    add2: null,
					city1:null,
					land1:null,
                    belnr:null,
                    zzbgdh:null,
                    orderCategory1:null,
                    pageSize: 10,
                    pageNo: 1,
                    total: 0
                },
                q:{
                    pageSize: 10,
                    pageNo: 1,
                    total: 0
                },
                multipleSelection: [],
                tableData2: [],
            }
        },
        created() {

        },
        methods: {
			// 展开折叠
			collapseChange(){
				this.isScreen = !this.isScreen;
			},
			downloadExcel(){
				//ids
				var cc = [];
				for (var d in this.tableData2.id) {
					cc.push(this.tableData2[d].id);
				}
				//查询参数
				var c = {
					ids: cc,
				};
				console.log("c====",c);
				console.log(this.formInline,'!!!!!!!!!!')
				updownfile.down("/api/swyl/v1/demo/viewOrderMoneyBack/downloadExcel", this.formInline, 'post');
				console.log("执行完了")
			},
            timeSelect() {
                this.formInline.sptgTime = this.value2[0];
                this.formInline.sptgTime1 = this.value2[1];
            },
			timeSelect1() {
				this.formInline.add5 = this.value1[0];
				this.formInline.add5I = this.value1[1];
			},
            //检索按钮功能
            selectData() {
                this.q.pageNo = 1;
                this.selectDataPage();
            },
            selectDataPage() {
                this.q.sapCode = this.formInline.sapCode?this.formInline.sapCode:null;
                this.q.soldToCode = this.formInline.soldToCode?this.formInline.soldToCode:null;
                this.q.add2 = this.formInline.add2?this.formInline.add2:null;
                this.q.city1=this.formInline.city1?this.formInline.city1:null;
				this.q.land1=this.formInline.land1?this.formInline.land1:null;
				this.q.belnr=this.formInline.belnr?this.formInline.belnr:null;
				this.q.zzbgdh=this.formInline.zzbgdh?this.formInline.zzbgdh:null;
				this.q.sptgTime=this.formInline.sptgTime?this.formInline.sptgTime:null;
				this.q.sptgTime1=this.formInline.sptgTime1?this.formInline.sptgTime1:null;
				this.q.add4=this.formInline.add4?this.formInline.add4:null;
				this.q.add5=this.formInline.add5?this.formInline.add5:null;
				this.q.add5I=this.formInline.add5I?this.formInline.add5I:null;
				this.q.gscode=this.formInline.gscode?this.formInline.gscode:null;
				this.q.zztidh=this.formInline.zztidh?this.formInline.zztidh:null;
                this.q.xdhao=this.formInline.xdhao?this.formInline.xdhao:null;
                this.q.zzzxjl=this.formInline.zzzxjl?this.formInline.zzzxjl:null;
                this.q.zzyffp=this.formInline.zzyffp?this.formInline.zzyffp:null;
                this.q.orderCategory1=this.formInline.orderCategory1?this.formInline.orderCategory1:null;
				this.q.orderCategory=this.formInline.orderCategory?this.formInline.orderCategory:null
                customerLedgerService.querybackList(this.q).then(response => {
                    console.log(response, '检索结果1')
                     this.tableData2 = response.records;
                    this.q.total = response.total;
                })
            },
			chooseModify() {
				if (this.moreCondition) {
					this.moreCondition = false;
				} else {
					this.moreCondition = true;
				}
			},
            //重置按钮功能
            resectData() {
                this.formInline.sapCode = null;
                this.formInline.soldToCode = null;
                this.formInline.add2 = null;
				this.formInline.city1 = null;
				this.formInline.sptgTime=null;
				this.formInline.sptgTime1=null;
				this.formInline.add4=null;
				this.formInline.gscode=null;
				this.formInline.zztidh=null;
				this.formInline.sptgTime=null,
				this.formInline.sptgTime1=null,
				this.formInline.add5=null,
				this.formInline.add5I=null,
				this.formInline.orderCategory=null;
                this.formInline.orderCategory1=null;
            },
            handleSelectionChange(val) {
                console.log(val,'val')
                this.multipleSelection = val;
            },
            handleSizeChange() {
                console.log(1)
            },
			seeFile(o){
				this.refid = this.ddhU = o.sapCode;
				this.showFujianD = true;
			},
            handleCurrentChange() {
                console.log(2)
            },
            handleScroll(e) {
                console.log(e.target.scrollLeft)
            }
        },
        mounted() {
            //查询所有信贷列表
            this.selectDataPage();
        }
    }
</script>
<style scoped>

    /* .selectorBox{
        width: 100%;
        padding: 0.54rem 0.28rem 0 0.25rem;
    }
    .selectorBox .text{
        margin-left: 0.38rem;
        font-size: 0.18rem;
        color: #4a4a4a;
        position: relative;
    }
    .selectorBox .text::before{
        content: "*";
        position: absolute;
        top: 0;
        left: -7px;
        color: red;
        font-size: 0.2rem;
    }
    .selectorBox .selector{
        margin-left: 0.38rem;
        margin-top: 20px;
        display: flex;
    }
    .selectorBox .selector .button{
        width: 65px;
        padding: 10px;
        color: #b7b7b7;
        border: 1px solid #dcdfe1;
        text-align: center;
        line-height: 20px;
        cursor: pointer;
    }
    .selectorBox .selector .button.active{
        color: #fff;
        background: #238cfd;
        border: 1px solid #238cfd;
    }
    .tip{
        margin-left: 1.6rem;
        color: #b0b0b0;
        font-size: 0.2rem;
        margin-top:10px;
    }
    .h-bgccc{
        background: #edf5fa;
        border-color: #959595;
        color: #92999e;
    } */
</style>
<style>
    /* .selectorBox .el-input-group__append{
        background: #238cfd;
        color: #fff
    }
    .selectorBox .el-upload-list{
        display: none;
    } */
    /* .h-rowIn .el-table .el-table__body-wrapper::-webkit-scrollbar {
        width: 10px;
        height: 10px;
    } */

    /* .drags .el-slider__button-wrapper .el-slider__button{
        background: url(../../../assets/images/drag.png) center/cover;
        border: 0;
        border-radius: 0;
        width: 20px;
        height: 20px;
    } */
    .zhi .h-formBorder .el-form-item__label {
        vertical-align: top;
    }

    .zhi .el-date-editor .el-range-separator {
        width: 9%;
        margin-bottom: 0;
    }
</style>
